import { ACTION_TYPES } from '../../utils/Constants';

const NotificationReducer = (
    state = {
        notificationDetails: 0,
    },
    action = {}
) => {
    switch (action.type) {
        case ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION:
            state = {
                ...state,
                notificationDetails: action.payload,
            };
            break;

        case ACTION_TYPES.INS_SUPER_ADMIN.READ_NOTIFICATION:
            state = {
                ...state,
                notificationDetails: action.payload,
            };
            break;
        default:
            break;
    }
    return state;
};
export default NotificationReducer;
